import type { PageContext } from 'vike/types'
import { useNavStore } from '@repo/ui'
export async function onCreatePinia(pageContext: PageContext) {
  const navStore = useNavStore(pageContext.pinia)
  navStore.setMode(pageContext.mode)
}
